import { render, staticRenderFns } from "./PermissionManage.vue?vue&type=template&id=f5b3de26&scoped=true"
import script from "./PermissionManage.vue?vue&type=script&lang=js"
export * from "./PermissionManage.vue?vue&type=script&lang=js"
import style0 from "./PermissionManage.vue?vue&type=style&index=0&id=f5b3de26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b3de26",
  null
  
)

export default component.exports